export default "__VITE_ASSET__Cbz$iW9Y__"